/* eslint-disable max-len */
import { IRootState } from '..';

export const SELECTOR_CONTEXT_MENU_IS_CONTEXT_MENU_VISIBLE = (state: IRootState) => state.ContextMenu.isContextMenuVisible;
export const SELECTOR_CONTEXT_MENU_CONTEXT_MENU_POSITION = (state: IRootState) => state.ContextMenu.contextMenuPosition;